import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRemoveIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 512 512",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Remove Bookmark" }), /* @__PURE__ */ _jsx("path", {
		fill: "#FF3131",
		d: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
	})]
});
export default SvgRemoveIcon;
